<template>
  <div class="fvlru typeBox ">
    <span v-for="item in typeList" :key="item.id" :class="[item.id === typeId ? 'active themeColor' : '']" @click.stop.self="clickLabel(item)">
      {{ item.label }}</span
    >
  </div>
  <AddPhone />
  <div class="planBox" v-for="item in planList" :key="item.id">
    <!-- couponType  0:领劵中心 1:致友计划 2: 保养套餐 3:礼包 -->
    <template v-if="item.loyaltyId">
      <div class="header fvlr" :class="{ disable: !isEnable }">
        <div class="fvl">
          <!-- <img class="iconR" src="../../assets/images/handshake1.png" alt="" /> -->
          <div>{{ item.loyaltyName }}</div>
          <!-- statusFlag=1 可使用 列表需展示 是否过期标识 -->
          <div class="coupon-reminder" v-if="item.isHasReminderCoupon && listStatusFlag === 1">有即将过期的卡券</div>
        </div>
        <div class="fvl">
          <!-- <van-icon v-show="isEnable" class="iconL" name="orders-o" /> -->
          <div class="headerLeft" @click.stop="toConsumptionDetail(item)">
            {{ isEnable ? '使用消费明细' : status(item) }}
          </div>
        </div>
      </div>
      <div class="contentBox">
        <div class="fvlru carInfo">
          <div class="content">
            车牌号：<span class="text">{{ item.carInfo?.plate || '暂无车牌号' }}</span>
          </div>
          <!-- <div class="verticalLine"></div> -->
          <!-- <div class="carAge">
          车龄：<span class="text">{{
            item.carInfo && item.carInfo.carAge ? `${item.carInfo && item.carInfo.carAge}年` : item.carInfo && item.carInfo.carAge === 0 ? '新车' : '暂无'
          }}</span>
        </div> -->
          <div v-if="isEnable && item.dealerInfo && item.dealerInfo.gssnCode" class="oabBtn" @click.stop="toOab(item)">
            {{ item.loyaltyTypeFlag == '2' ? '去购买' : '去预约' }}
          </div>
        </div>
        <div class="fvl carInfo">
          <div class="content">
            底盘号：<span class="text">{{ item.carInfo?.fin || '暂无底盘号' }}</span>
          </div>
        </div>
        <div class="fvl carInfo">
          <div class="content">
            车架号：<span class="text">{{ item.carInfo?.vin || '暂无车架号' }}</span>
          </div>
        </div>
        <div class="fvlr" :class="{ carInfo: isEnable, dealer: !isEnable }">
          <div class="fvl">
            购买经销商：
            <div class="content">
              <span class="text">{{ item?.dealerInfo?.name }}</span>
            </div>
          </div>
          <a :href="`tel:${item?.dealerInfo?.tel}`">
            <van-icon class="phone" name="phone" />
          </a>
        </div>
        <div v-if="isEnable" class="fvlr dealer">
          <div class="fvl">
            可使用经销商：
            <div class="content">
              <span class="text underline" @click="viewUseDealerFn(item)">
                点击查看
              </span>
            </div>
          </div>
        </div>
        <div v-if="item.rightCoupon" v-show="show === item.id">
          <CouponCard :dealer="item.dealerInfo.name" :datas="filterData(item.rightCoupon)" :listStatusFlag="listStatusFlag" @showDeatail="showCouponDetail" />
        </div>
        <van-divider dashed></van-divider>
        <div class="show" @click="show = show === item.id ? false : item.id" v-if="item.statusFlag && item.statusFlag === 1">
          <van-icon :name="show === item.id ? 'arrow-up' : 'arrow-down'" />
          {{ show === item.id ? '收起' : '展开' }}详情
        </div>
      </div>
    </template>
    <template v-else>
      <ShopProductCard
        :listStatusFlag="listStatusFlag"
        :datas="item"
        @viewUse="viewUseDealerFn(item)"
        @viewContract="viewContractFn(item)"
        @showProductDetail="showProductDetailFn(item)"
      ></ShopProductCard>
    </template>
  </div>
  <CouponDetail :showPopUp="showCouponDetailNum" :showQR="showQR" :datas="[couponDetail]" scene="myRight" @viewUseDealer="viewUseDealerFn" />

  <teleport to="#dialog">
    <ShopCardDetail
      :showPopUp="showProductDetailNum"
      :showQR="true"
      :datas="productDetail || {}"
      scene="myRight"
      @viewUseDealer="viewUseDealerFn"
      @viewContract="viewContractFn"
    />
  </teleport>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import CouponCard from '@/components/plan/CouponCard'
import CouponDetail from '@/components/plan/CouponDetail'
import AddPhone from '@/components/plan/AddPhone'
import ShopProductCard from '@/components/directSales/ProductCard'
import ShopCardDetail from '@/components/directSales/ProductCardDetail'
import _ from 'lodash'

export default {
  props: ['datas', 'isEnable', 'listStatusFlag'],
  emits: ['viewUseDealer', 'loadData', 'viewContract'],
  components: {
    CouponCard,
    ShopProductCard,
    CouponDetail,
    ShopCardDetail,
    AddPhone
  },
  setup(props, { emit }) {
    const router = useRouter()
    const store = useStore()
    let { datas, isEnable, listStatusFlag } = toRefs(props)
    const state = reactive({
      typeList: [
        { label: '全部', id: '0', val: 'all' },
        { label: '延保', id: '101', val: 'ew' },
        { label: '礼包', id: '3', val: 'gift' },
        { label: '保养套餐', id: '2', val: 'maintain' },
        { label: '致友计划', id: '1', val: 'loyalty' },
        { label: '轮胎套餐', id: '4', val: 'tyre' }
      ],
      typeId: '0',
      show: false,
      planList: datas,
      isEnable,
      showCouponDetailNum: 0,
      showProductDetailNum: 0,
      couponDetail: {},
      productDetail: {},
      showQR: true,
      listStatusFlag,
    })
    const clickLabel = data => {
      if (state.typeId === data.id) {
        return
      }
      state.typeId = data.id
      emit('loadData', data)
    }
    let status = val => {
      if (val.shiftGivePlanStatus === 1) {
        return '已转赠'
      }
      if (val.bindStatus === 0) {
        return '已解绑'
      }
      let n = val.statusFlag
      let result = ['', '生效中', '已过期', '已作废']
      return result[n]
    }
    let showCouponDetail = data => {
      state.showQR = !(data.rightTypeFlag === 12)
      state.showCouponDetailNum += 1
      state.couponDetail = data
    }
    let showProductDetailFn = data => {
      state.showProductDetailNum += 1
      state.productDetail = data
      // console.log('showProductDetailFn', data)
    }
    //到消费明细页面
    const toConsumptionDetail = item => {
      // console.log("toConsumptionDetail", item);
      if (state.isEnable && item.loyaltyId && item.gsCode) {
        router.push({
          path: '/consumptionDetail',
          query: {
            loyaltyId: item.loyaltyId,
            customerPlanId: item.id,
            gsCode: item.gsCode,
            event: '查看致友计划消费明细'
          }
        })
      }
    }

    // 去oab预约页面
    let toOab = data => {
      if (data.loyaltyTypeFlag == 2) {
        if (data.tyreId && data.priceTypeFlag == 3 && data.loyaltyTypeFlag == 2) {
          store.commit('SETCURRENTTYRE', data)
          router.push({
            path: '/tyreDetail',
            query: {
              from: 'myLoyaltyTyre',
              tyreId: data.tyreId,
              customerLoyaltyPlanId: data?.rightCoupon[0].customerLoyaltyPlanId,
              plate: data.carInfo.plate,
              model: data.carInfo.model,
              cityId: data.carInfo.cityId,
              gsCode: data.gsCode,
              tyrePackageLoyaltyList: JSON.stringify([]),
              event: '轮胎详情'
            }
          })
        } else {
          router.push({
            path: '/tyreList',
            query: { from: 'tyreCoupon', event: '轮胎列表' }
          })
        }
      } else {
        let { dealerInfo, carInfo } = data
        store.dispatch('setOabInfo', { dealerInfo, carInfo })
        router.push({ path: '/oabCreate', query: { from: 'myPlanList' } })
      }
    }
    // 06.16,孙馨，不展示已过期的权益（1:未生效 2:可使用 3:已过期 4:暂不可用 5.已使用,6.使用中）
    // let filterData = data => (state.isEnable ? data.filter(item => item.statusFlag !== 3) : data)
    let filterData = datas => {
      let data = datas || []
      let res = []
      if (state.isEnable) {
        // 优化排序：临期卡券优先展示，可使用 + 已过期 + 其他，按照有效期结束时间从近到远排列
        res = _.orderBy(data, [
          (item) => Number(item.isReminder),
          (item) => item.statusFlag === 2 ? 0 : [1, 4, 5, 6].includes(item.statusFlag) ? 1 : 2,
          (item) => new Date(item.activeEndTime).getTime(),
        ], ['desc','asc','asc']);
      } else {
        res = data
      }
      return res
    }
    const viewUseDealerFn = data => {
      emit('viewUseDealer', data)
    }
    const viewContractFn = data => {
      emit('viewContract', data)
    }
    return {
      ...toRefs(state),
      status,
      toConsumptionDetail,
      showCouponDetail,
      showProductDetailFn,
      toOab,
      filterData,
      viewUseDealerFn,
      viewContractFn,
      clickLabel
    }
  }
}
</script>

<style lang="scss" scoped>
.typeBox {
  padding: 10px;
  background: #fff;
  border-top: 1px solid #ccc;
  span {
    padding: 4px 8px;
    border: 1px solid #f5f5f5;
    border-radius: 15px;
    background: #f5f5f5;
  }
  .active {
    border: 1px solid #3088c5;
    font-weight: 700;
    background: #fff;
  }
}
.planBox {
  // box-shadow: 2px 2px 2px red;
  background: #ffffff;
}
.header {
  color: #ffffff;
  margin-top: 16px;
  padding: 10px 14px;
  font-size: 14px;
  background-color: #3088c5;
  text-align: left;
  img {
    width: 18px;
    height: 16px;
  }
  .iconR {
    margin-right: 8px;
  }
  .iconL {
    margin-right: 4px;
  }
}
.headerLeft {
  font-size: 12px;
}
.disable {
  background-color: #cccccc;
}
.contentBox {
  font-size: 14px;
  color: #666666;
  padding: 16px 20px 0 20px;
  box-sizing: border-box;
  background: #ffffff;
  .text {
    font-size: 12px;
    opacity: 0.8;
  }
}
.carInfo {
  margin-bottom: 8px;
}
.verticalLine {
  padding: 0 15px;
}
.dealer {
  margin-bottom: 20px;
}
.phone {
  font-size: 24px;
  color: #3088c5;
  transform: rotate(-90deg);
  float: right;
}
.van-divider {
  margin: 4px 0 0;
}
.van-divider--hairline::before {
  transform: scaleY(1.5);
}
.show {
  padding: 10px 0;
}
.oabBtn {
  width: 50px;
  height: 18px;
  font-size: 12px;
  line-height: 18px;
  color: #3088c5;
  border: 1px solid #3088c5;
}
.coupon-reminder{
  margin-left: 10px;
  font-size: 10px;
  color: red;
}
</style>
